import { createEpic } from '../helpers';
import { feedbackCreateFeedbackAsyncAction } from './feedbackActions';

export const createFeedbackEpic = createEpic(
	feedbackCreateFeedbackAsyncAction,
	'feedback',
	'create',
	true
);
